import { useMutation } from "@apollo/client";
import { CREATE_WANTED_ITEM } from "../wantedItemTypeDefs";

export const useMutationCreateWantedItem = (options?: any): any => (
  useMutation(CREATE_WANTED_ITEM, options)
);
